import { useForgotPassword } from "@refinedev/core";
import { Button, Form, Row, Space } from "antd";
import type { FC } from "react";
import { FormInputPassword, FormItem, type Validator } from "ui/form";

const checkPasswordComplexity = (value: string) => {
  const hasNumber = /\d/.test(value);
  const hasUpperCase = /[A-Z]/.test(value);
  const hasLowerCase = /[a-z]/.test(value);
  const hasSpecialChar = /[!@#$%^&*]/.test(value);
  const valid =
    (hasNumber && (hasUpperCase || hasLowerCase || hasSpecialChar)) ||
    (hasUpperCase && (hasNumber || hasLowerCase || hasSpecialChar)) ||
    (hasLowerCase && (hasNumber || hasUpperCase || hasSpecialChar)) ||
    (hasSpecialChar && (hasNumber || hasUpperCase || hasLowerCase));
  return valid;
};
interface IResetPasswordProps {
  isNextButtonLoading?: boolean;
}
export const ResetPassword: FC<IResetPasswordProps> = ({
  isNextButtonLoading,
}) => {
  const [form] = Form.useForm();
  const { mutate: mutateForgotPassword } = useForgotPassword();

  const validatePassword: Validator = (rule, value, callback) => {
    const valid = checkPasswordComplexity(value);

    if (!valid) {
      callback("パスワードの形式が正しくありません。");
      return;
    }

    callback();
  };
  const validateRepeatPassword: Validator = (rule, value, callback) => {
    const valid = checkPasswordComplexity(value);
    if (!valid) {
      callback("パスワードの形式が正しくありません。");
      return;
    }
    if (value && form.getFieldValue("password") !== value) {
      callback("二回入力されたパスワードが一致していません。");
      return;
    }

    callback();
  };

  return (
    <Form form={form} name="reset" layout="vertical">
      <FormItem
        label="パスワード"
        extra="パスワードは10〜50桁で、アルファベットの大文字と数字と記号の入力が必要です。"
      >
        <FormInputPassword
          name="password"
          placeholder="パスワードを入力してください"
          rules={[{ validator: validatePassword }]}
        />
        <FormInputPassword
          name="confirmPassword"
          placeholder="もう一回入力してください"
          rules={[{ validator: validateRepeatPassword }]}
        />
      </FormItem>
      <Row justify="center">
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            loading={isNextButtonLoading}
          >
            確認
          </Button>
        </Space>
      </Row>
    </Form>
  );
};
